import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DepartmentDisbursementSettingListResponse,
  DepartmentDisbursementSettingModel,
  DepartmentDisbursementSettingPayload,
  DisbursementDefaultSettingModel,
  DisbursementDefaultSettingPayload,
  DisbursementFinanceOfficerListResponse,
  DisbursementTermSettingModel,
  DisbursementTermSettingPayload,
} from '../../models/disbursement/disbursement-settings.model';

// Admin (หัวหน้างานบริหาร) settings service for disbursement configuration.
@Injectable({
  providedIn: 'root',
})
export class DisbursementSettingsService {
  private departmentApiUrl = '/department_disbursement_settings';
  private termApiUrl = '/disbursement_term_settings';
  private defaultApiUrl = '/disbursement_default_setting';

  #http = inject(HttpClient);

  // ADR-DF: values and lock are per (department, term) — the term is required on both calls.
  getDepartmentSettings(academicTermId: number): Observable<DepartmentDisbursementSettingListResponse> {
    return this.#http.get<DepartmentDisbursementSettingListResponse>(this.departmentApiUrl, {
      params: new HttpParams().set('academic_term_id', academicTermId),
    });
  }

  updateDepartmentSetting(
    departmentId: number,
    academicTermId: number,
    payload: DepartmentDisbursementSettingPayload,
  ): Observable<DepartmentDisbursementSettingModel> {
    return this.#http.patch<DepartmentDisbursementSettingModel>(
      `${this.departmentApiUrl}/${departmentId}`,
      { ...payload, academic_term_id: academicTermId },
    );
  }

  getFinanceOfficers(): Observable<DisbursementFinanceOfficerListResponse> {
    return this.#http.get<DisbursementFinanceOfficerListResponse>(`${this.departmentApiUrl}/finance_officers`);
  }

  getTermSetting(academicTermId: number): Observable<DisbursementTermSettingModel> {
    return this.#http.get<DisbursementTermSettingModel>(`${this.termApiUrl}/${academicTermId}`);
  }

  updateTermSetting(
    academicTermId: number,
    payload: DisbursementTermSettingPayload,
  ): Observable<DisbursementTermSettingModel> {
    return this.#http.patch<DisbursementTermSettingModel>(`${this.termApiUrl}/${academicTermId}`, payload);
  }

  // The current defaults ride along with getDepartmentSettings() — no separate GET.
  updateDefaultSetting(
    payload: DisbursementDefaultSettingPayload,
  ): Observable<DisbursementDefaultSettingModel> {
    return this.#http.patch<DisbursementDefaultSettingModel>(this.defaultApiUrl, payload);
  }
}
